import { useState, useCallback, useEffect } from "react";
import Subheader from "./subheader";
import uploadImg from "../../images/uploadImg.jpg";
import calendarblueIcon from "../../images/calendarblueIcon.svg";
import clockIcon from "../../images/clockIcon.svg";
import { resources_EN } from "../componentUtils";
import { Path } from "../../RoutesUtils";
import moment from "moment";
import { PostServiceWithFile } from "../../services/genericPostService";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Header from "../header/header";

export default function Edittask() {
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [hours, setHours] = useState("20");
  const [minutes, setMinutes] = useState("00");
  const [ampm, setAmpm] = useState("AM");
  const [image, setImage] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [formData, setFormData] = useState({
    taskDate: "",
    taskTime: "",
    taskTitle: "",
    taskDesc: "",
    taskFile: "",
    taskId: 0,
  });

  const [startHours, setStartHours] = useState("00");
  const [startMinutes, setStartMinutes] = useState("00");
  const [endHours, setEndHours] = useState("00");
  const [endMinutes, setEndMinutes] = useState("00");
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");
  const location = useLocation();

  const token = localStorage.getItem("token");
  useEffect(() => {
    if (!token) {
      navigate(Path.login);
    }
  }, []);

  const handleDrag = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  const handleDragIn = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  }, []);

  const handleDragOut = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  }, []);

  const handleDrop = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const file = e.dataTransfer.files[0];
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  }, []);

  const handleFileChange = useCallback((e) => {
    console.log("Event", e.target.files);
    const file = e.target.files?.[0];
    setFormData((prevState) => ({
      ...prevState,
      taskFile: file,
    }));
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  }, []);

  const removeImage = useCallback(() => {
    setImage(null);
    setFormData((prevState) => ({
      ...prevState,
      taskFile: "",
    }));
  }, []);

  useEffect(() => {
    if (location.state) {
      const data = location.state;
      console.log("Data", data);
      setFormData((prevState) => ({
        taskTitle: data.task_title,
        taskId: data.presc_id,
        taskDesc: data.task_desc,
        taskDate: data.task_date,
        taskFile: data.task_image,
      }));
      setStartHours(moment(data.task_start_time, "HH:mm").format("HH"));

      setStartMinutes(moment(data.task_start_time, "HH:mm").format("mm"));

      setEndHours(moment(data.task_end_time, "HH:mm").format("HH"));

      setEndMinutes(moment(data.task_end_time, "HH:mm").format("mm"));
      console.log("Data", data);
      const url = "../../fmeApi/" + data.task_image;
      console.log("Url", url);
      setImage(url);
    }
  }, []);

  const submit = () => {
    const validate = validation();
    if (validate) {
      const startTime = moment({
        hour: startHours,
        minute: startMinutes,
      }).format("HH:mm:ss");
      const endTime = moment({ hour: endHours, minute: endMinutes }).format(
        "HH:mm:ss"
      );

      const data = new FormData();
      data.append("task_date", formData.taskDate);
      data.append("task_title", formData.taskTitle);
      data.append("task_description", formData.taskDesc);
      data.append("task_file", formData.taskFile); // Correct way to attach a file
      data.append("task_start_time", startTime);
      data.append("task_end_time", endTime);
      data.append("user_id", userId);
      data.append("task_id", location.state.task_id);

      const url = "/fmeApi/edit_task.php";
      PostServiceWithFile(url, data, modal);
    }
  };

  const onChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  /* Error or Success Modal */
  const modal = (icon, title, message) => {
    Swal.fire({
      icon: icon,
      title: title,
      text: message,
    }).then((response) => {
      if (response.isConfirmed && icon === resources_EN.success) {
        console.log("Success");
        navigate(Path.toDoList);
      }
    });
  };

  const validation = () => {
    if (formData.taskTitle.trim().length < 1) {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.emptyTaskTitleValidation
      );
      return false;
    }
    if (formData.taskDesc.trim().length < 1) {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.emptyTaskDescValidation
      );
      return false;
    }
    if (formData.taskFile === "") {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.emptyFileValidation
      );
      return false;
    }
    if (formData.taskDate.trim().length < 1) {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.emptyTaskDate
      );
      return false;
    }
    if (startHours.length < 1) {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.emptyTaskStarHour
      );
      return false;
    }
    if (startMinutes.length < 1) {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.emptyTaskStartMinute
      );
      return false;
    }
    if (endHours.length < 1) {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.emptyTaskEndHour
      );
      return false;
    }
    if (endMinutes.length < 1) {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.emptyTaskEndMinute
      );
      return false;
    }
    return true;
  };

  return (
    <>
      <Header />
      <Subheader title="Rediger opgave" />
      <div className="max-w-xl mx-auto p-6 space-y-6">
        <div
          className={`relative p-6 max-w-xs mx-auto`}
          onDragEnter={handleDragIn}
          onDragLeave={handleDragOut}
          onDragOver={handleDrag}
          onDrop={handleDrop}
        >
          {image ? (
            <div className="relative">
              <img
                src={image}
                alt="Uploaded preview"
                className="max-h-48 mx-auto rounded-lg object-contain"
              />
              <button
                onClick={removeImage}
                className="absolute -top-5 right-0 w-7 h-7 flex justify-center items-center bg-red-500 text-white rounded-full p-3"
              >
                ✖
              </button>
            </div>
          ) : (
            <label className="flex flex-col items-center gap-2 cursor-pointer">
              <input
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                className="hidden"
              />
              <img src={uploadImg} alt="" />
              <p className="text-sm text-black">
                Upload relevant image for this task *
              </p>
            </label>
          )}
        </div>

        <div className="space-y-2">
          <label htmlFor="title" className="block text-sm font-medium">
            Task Title *
          </label>
          <input
            type="text"
            id="title"
            className="w-full border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none transition duration-300 text-gray-900 text-base py-2"
            placeholder="Enter Task Title"
            name="taskTitle"
            onChange={onChange}
            value={formData.taskTitle}
          />
        </div>

        <div className="space-y-2">
          <label htmlFor="description" className="block text-sm font-medium">
            Task Description *
          </label>
          <textarea
            type="text"
            id="description"
            className="w-full border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none transition duration-300 text-gray-900 text-base py-2"
            placeholder="Enter Task details"
            value={formData.taskDesc}
            onChange={onChange}
            name="taskDesc"
          />
        </div>

        <div className="grid grid-cols-2 md:gap-8 gap-4">
          {/* Date Picker */}
          <div className="space-y-2">
            <label className="block text-sm font-medium">Task Date *</label>
            <div className="relative">
              <div className="bg-[#F3F3F3] rounded-2xl md:py-4 py-3">
                <label className="text-sm font-medium mb-3 block text-theme md:px-4 px-3">
                  Select Date
                </label>
                <div className="flex justify-between items-center mt-8 border-b pb-4 mb-4">
                  <div className="flex gap-4 md:px-4 px-3">
                    <button className="text-sm font-medium text-back">
                      Enter Date
                    </button>
                  </div>
                  <div className="md:px-4 px-3">
                    <img src={calendarblueIcon} alt="" />
                  </div>
                </div>
                <div className="md:px-4 px-3">
                  <input
                    type="date"
                    value={formData.taskDate}
                    name="taskDate"
                    onChange={onChange}
                    className="w-full border-2 border-[#2BBAF0] focus:border-[#2BBAF0] focus:outline-none rounded-lg p-2 text-black"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Time Picker */}
          <div className="space-y-2">
            <label className="block text-sm font-medium">
              Task Start Time *
            </label>
            <div className="relative">
              <div className="bg-[#F3F3F3] rounded-2xl md:p-4 p-3">
                <label className="text-sm font-medium mb-3 block">
                  Enter time
                </label>
                <div className="grid grid-cols-3 md:gap-4 gap-3 mb-4">
                  <div className="relative">
                    <input
                      type="number"
                      value={startHours}
                      onChange={(e) => setStartHours(e.target.value)}
                      className="w-full border-2 focus:bg-[#EADDFF] bg-[#E6E0E9] focus:text-[#2BBAF0] focus:border-[#2BBAF0] focus:outline-none rounded-xl py-2 text-center md:text-3xl text-xl text-black"
                      min="1"
                      max="12"
                      required
                      name="startHours"
                    />
                    <label className="text-gray-500 md:text-sm text-xs mb-1">
                      Hour
                    </label>
                    <span className="absolute md:-right-[19%] -right-[23%] md:top-[30%] top-[28%] transform -translate-y-2/4 md:text-2xl text-lg font-bold text-black">
                      :
                    </span>
                  </div>
                  <div>
                    <input
                      type="number"
                      value={startMinutes}
                      onChange={(e) => setStartMinutes(e.target.value)}
                      name="startMinutes"
                      className="w-full border-2 focus:bg-[#EADDFF] bg-[#E6E0E9] focus:text-[#2BBAF0] focus:border-[#2BBAF0] focus:outline-none rounded-xl py-2 text-center md:text-3xl text-xl text-black"
                      min="0"
                      max="59"
                      required
                    />
                    <label className="text-gray-500 md:text-sm text-xs mb-1">
                      Minute
                    </label>
                  </div>
                  <div className="flex justify-end items-center gap-4 mb-4">
                    {/* <div className="flex flex-col rounded-xl overflow-hidden border border-gray-200">
                      <button
                        type="button"
                        onClick={() => setAmpm("AM")}
                        className={`md:px-4 px-2 py-2 md:text-md text-xs font-medium ${
                          ampm === "AM"
                            ? "bg-green text-theme"
                            : "bg-white text-gray-700"
                        }`}
                      >
                        AM
                      </button>
                      <button
                        type="button"
                        onClick={() => setAmpm("PM")}
                        className={`md:px-4 px-2 py-2 md:text-md text-xs font-medium ${
                          ampm === "PM"
                            ? "bg-green text-theme"
                            : "bg-white text-gray-700"
                        }`}
                      >
                        PM
                      </button>
                    </div> */}
                  </div>
                </div>
                <div className="flex justify-between items-center">
                  <div>
                    <img src={clockIcon} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="space-y-2">
            <label className="block text-sm font-medium">Task End Time *</label>
            <div className="relative">
              <div className="bg-[#F3F3F3] rounded-2xl md:p-4 p-3">
                <label className="text-sm font-medium mb-3 block">
                  Enter time
                </label>
                <div className="grid grid-cols-3 md:gap-4 gap-3 mb-4">
                  <div className="relative">
                    <input
                      type="number"
                      value={endHours}
                      onChange={(e) => setEndHours(e.target.value)}
                      className="w-full border-2 focus:bg-[#EADDFF] bg-[#E6E0E9] focus:text-[#2BBAF0] focus:border-[#2BBAF0] focus:outline-none rounded-xl py-2 text-center md:text-3xl text-xl text-black"
                      min="1"
                      max="12"
                      required
                    />
                    <label className="text-gray-500 md:text-sm text-xs mb-1">
                      Hour
                    </label>
                    <span className="absolute md:-right-[19%] -right-[23%] md:top-[30%] top-[28%] transform -translate-y-2/4 md:text-2xl text-lg font-bold text-black">
                      :
                    </span>
                  </div>
                  <div>
                    <input
                      type="number"
                      value={endMinutes}
                      onChange={(e) => setEndMinutes(e.target.value)}
                      className="w-full border-2 focus:bg-[#EADDFF] bg-[#E6E0E9] focus:text-[#2BBAF0] focus:border-[#2BBAF0] focus:outline-none rounded-xl py-2 text-center md:text-3xl text-xl text-black"
                      min="0"
                      max="59"
                      required
                    />
                    <label className="text-gray-500 md:text-sm text-xs mb-1">
                      Minute
                    </label>
                  </div>
                  <div className="flex justify-end items-center gap-4 mb-4">
                    {/* <div className="flex flex-col rounded-xl overflow-hidden border border-gray-200">
                      <button
                        type="button"
                        onClick={() => setAmpm("AM")}
                        className={`md:px-4 px-2 py-2 md:text-md text-xs font-medium ${
                          ampm === "AM"
                            ? "bg-green text-theme"
                            : "bg-white text-gray-700"
                        }`}
                      >
                        AM
                      </button>
                      <button
                        type="button"
                        onClick={() => setAmpm("PM")}
                        className={`md:px-4 px-2 py-2 md:text-md text-xs font-medium ${
                          ampm === "PM"
                            ? "bg-green text-theme"
                            : "bg-white text-gray-700"
                        }`}
                      >
                        PM
                      </button>
                    </div> */}
                  </div>
                </div>
                <div className="flex justify-between items-center">
                  <div>
                    <img src={clockIcon} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-center">
          <button
            type="button"
            onClick={submit}
            className="py-1.5 px-16 border border-transparent rounded-full text-sm font-normal text-white bg-theme focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-theme cursor-pointer"
          >
            Save
          </button>
        </div>
      </div>
    </>
  );
}
